// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @vowkey/platform/no-enums
export enum OrganizationConnectionType {
  CloudBillingSync = 1,
  Scim = 2,
}
